module.exports = __webpack_public_path__ + "img/yearly_redeem_transaction_count.56fdd835.svg";